import React, { useEffect } from "react";
import Aos from "aos";
import 'aos/dist/aos.css';
import { PAGE_52 } from "./assets";
import styles from './BoardAnimation.module.scss'; 

export default function BoardAnimation() {

    useEffect(() => {
        Aos.init(); 
    }, []); 

    return (
        <div className={styles["container"]}>
            <div className={styles["top-board"]} data-aos="zoom-in" data-aos-duration="500">
                <img src={PAGE_52.BOX_1.default} alt="Board 1" />
            </div>
            <div className={styles["bottom-board"]} data-aos="zoom-in" data-aos-duration="500">
                <img src={PAGE_52.BOX_2.default} alt="Board 2" />
            </div>
            <div className={styles["right-character"]} data-aos="fade-right" data-aos-duration="1000">
                <img src={PAGE_52.RIGHT_CHARACTER.default} alt="Right character" />
            </div>
            <div className={styles["left-character"]} data-aos="fade-left" data-aos-duration="1000">
                <img src={PAGE_52.LEFT_CHARACTER.default} alt="Left character" />
            </div>
        </div>
    )
}